import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Auth, authState } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Component({
    selector: 'is-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    standalone: false
})
export class ShellComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => result.matches),
      shareReplay(1)
    );

  loggedIn$: Observable<boolean> = authState(this.afAuth).pipe(
    map(user => !!user)
  )

  onSignOut() {
    this.afAuth.signOut()
    this.router.navigate(['/user', 'login'])
  }

  constructor(
    public afAuth: Auth,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) {}
}
